import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'placeholderIfEmpty',
})
export class PlaceholderIfEmptyPipe implements PipeTransform {
  transform(value: string | undefined): any {
    if (!value) {
      return (
        'data:image/svg+xml;utf8,' +
        encodeURIComponent(
          `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='300'>
          <rect width='100%' height='100%' fill='#f3f3f3'/>
          <text x='50%' y='50%' font-family='Arial' font-size='20' fill='#aaa' text-anchor='middle'>Sin imagen</text>
          </svg>`
        )
      );
    }
    return value;
  }
}
